import { APP_TRANSACTION } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { AppTransactionDetailRequestModel } from "./models/AppTransactionDetailRequestModel";
import { AppTransactionListRequestModel } from "./models/AppTransactionListRequestModel";
import { AppTransactionResponseModel } from "./models/AppTransactionResponseModel";

export interface IAppTransactionRepository {
  getList(
    params: AppTransactionListRequestModel
  ): Promise<ListBaseApiResponseModel<AppTransactionResponseModel>>;
  getDetail(
    params: AppTransactionDetailRequestModel
  ): Promise<BaseApiResponseModel<AppTransactionResponseModel>>;
  exportReport(
    params: AppTransactionListRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
  checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<AppTransactionResponseModel>>;
}

@injectable()
export class AppTransactionImpl implements IAppTransactionRepository {
  async getList(
    params: AppTransactionListRequestModel
  ): Promise<ListBaseApiResponseModel<AppTransactionResponseModel>> {
    return await client?.get(APP_TRANSACTION?.LIST, params);
  }
  async getDetail(
    params: AppTransactionDetailRequestModel
  ): Promise<BaseApiResponseModel<AppTransactionResponseModel>> {
    return await client?.get(APP_TRANSACTION?.DETAIL, params);
  }
  async exportReport(
    params: AppTransactionListRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    const queryString = new URLSearchParams(params as any).toString();
    const url = `${APP_TRANSACTION.LIST}?${queryString}`;
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
  async checkStatus(
    code: string
  ): Promise<BaseApiResponseModel<AppTransactionResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
